/* ============================================================
   HERO EMERALD ENGINE  —  hero-calligraphy.js
   ─────────────────────────────────────────────────────────────
   Emerald ribbon hero. On every SPA home-page visit manages:
     1. Dust particles (built once per visit)
     2. Three-layer mouse parallax at 60 FPS (ribbon / glass / dust)
     3. Golden shimmer sweep every 10–15 s (adds .is-sweeping to SVG rect)
     4. Content reveal cascade (eyebrow → headline → sub → CTA → meta)
     5. Page-visibility pause / resume (no animation jump)

   CSS in style.css owns: gradient background, ribbon SVG styles,
   glass shape float keyframes, particle keyframes, reveal transitions.
   This file only touches class additions and style.transform.
   ============================================================ */
(function () {
  'use strict';

  /* ── State ────────────────────────────────────────────────── */
  var mouseX  = 0, mouseY  = 0;
  var currX   = 0, currY   = 0;
  var rafId   = null;
  var shimT   = null;
  var visBound = false;

  /* ── Helpers ──────────────────────────────────────────────── */
  function $(id) { return document.getElementById(id); }
  function show(id) { var el = $(id); if (el) el.classList.add('is-in'); }

  /* ── Dust particles ───────────────────────────────────────── */
  function buildParticles() {
    var layer = $('heroDustLayer');
    if (!layer || layer.childElementCount > 0) return;
    var anims = ['dpA', 'dpB', 'dpC'];
    for (var i = 0; i < 24; i++) {
      var size  = 1.2 + Math.random() * 2.4;
      var left  = 32  + Math.random() * 65;
      var top   = 5   + Math.random() * 88;
      var dur   = 24  + Math.random() * 32;
      var delay = -(Math.random() * dur);
      var dx    = (Math.random() - 0.5) * 38;
      var dy    = -(18 + Math.random() * 72);
      var anim  = anims[i % 3];
      var p = document.createElement('div');
      p.className = 'dp';
      p.style.cssText = [
        'width:'  + size.toFixed(1) + 'px',
        'height:' + size.toFixed(1) + 'px',
        'left:'   + left.toFixed(1) + '%',
        'top:'    + top.toFixed(1)  + '%',
        '--dx:'   + dx.toFixed(1)   + 'px',
        '--dy:'   + dy.toFixed(1)   + 'px',
        'animation:' + anim + ' ' + dur.toFixed(1) + 's ease-in-out ' + delay.toFixed(1) + 's infinite'
      ].join(';');
      layer.appendChild(p);
    }
  }

  /* ── Mouse parallax ───────────────────────────────────────── */
  function onMouseMove(e) {
    mouseX = (e.clientX / window.innerWidth  - 0.5) * 2;
    mouseY = (e.clientY / window.innerHeight - 0.5) * 2;
  }

  function tick() {
    currX += (mouseX - currX) * 0.055;
    currY += (mouseY - currY) * 0.055;

    /* Ribbon: deepest layer, least movement */
    var rl = $('ribbonLayer');
    if (rl) rl.style.transform =
      'translate(' + (-currX * 7).toFixed(1) + 'px,' + (-currY * 4).toFixed(1) + 'px)';

    /* Glass shapes: mid layer */
    var gl = $('glassLayer');
    if (gl) gl.style.transform =
      'translate(' + (-currX * 16).toFixed(1) + 'px,' + (-currY * 11).toFixed(1) + 'px)';

    /* Particles: nearest layer, most reactive */
    var dl = $('heroDustLayer');
    if (dl) dl.style.transform =
      'translate(' + (currX * 22).toFixed(1) + 'px,' + (currY * 14).toFixed(1) + 'px)';

    rafId = requestAnimationFrame(tick);
  }

  /* ── Shimmer scheduler ────────────────────────────────────── */
  function scheduleShimmer() {
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    shimT = setTimeout(function () {
      var el = $('ribbonShimmer');
      if (el && !el.classList.contains('is-sweeping')) {
        el.classList.add('is-sweeping');
        setTimeout(function () {
          var e = $('ribbonShimmer');
          if (e) e.classList.remove('is-sweeping');
        }, 3800);
      }
      scheduleShimmer();
    }, 10000 + Math.random() * 5000);
  }

  /* ── Content reveal ───────────────────────────────────────── */
  function revealContent() {
    /* Heading and eyebrow are visible immediately — CSS has no hidden state.
       Only subtext, CTA, and meta get a light stagger for polish. */
    show('muEyebrow');
    show('muH1');
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function timed(id, d) {
      setTimeout(function () { show(id); }, reduced ? 0 : d);
    }
    timed('muSub',  280);
    timed('muCta',  520);
    timed('muMeta', 800);
  }

  /* ── Cleanup before re-entry ──────────────────────────────── */
  function cleanup() {
    if (rafId)  { cancelAnimationFrame(rafId); rafId = null; }
    if (shimT)  { clearTimeout(shimT);         shimT = null; }
    document.removeEventListener('mousemove', onMouseMove);
    mouseX = 0; mouseY = 0; currX = 0; currY = 0;

    /* Reset reveal classes so cascade re-runs cleanly */
    ['muEyebrow', 'muH1', 'muSub', 'muCta', 'muMeta'].forEach(function (id) {
      var el = $(id);
      if (el) el.classList.remove('is-in');
    });

    /* Clear old dust */
    var dl = $('heroDustLayer');
    if (dl) dl.innerHTML = '';
  }

  /* ── Visibility pause / resume ────────────────────────────── */
  function bindVisibility() {
    if (visBound) return;
    visBound = true;
    document.addEventListener('visibilitychange', function () {
      document.body.classList.toggle('tab-hidden', document.hidden);
      if (document.hidden) {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        if (shimT) { clearTimeout(shimT);         shimT = null; }
      } else {
        if (!rafId) rafId = requestAnimationFrame(tick);
        scheduleShimmer();
      }
    }, { passive: true });
    if (document.hidden) document.body.classList.add('tab-hidden');
  }

  /* ── Public init — called by SPA router on every home visit ─ */
  window.initHeroCalligraphy = function () {
    cleanup();
    buildParticles();
    bindVisibility();

    document.addEventListener('mousemove', onMouseMove, { passive: true });

    if (!document.hidden) {
      rafId = requestAnimationFrame(tick);
      revealContent();
      setTimeout(scheduleShimmer, 5000);
    }
  };

})();
